import React from "react";
import { locales } from "../../locales";
import { getDataSource } from "../../services/api";
import CandidateImage from "./CandidateImage";

const CandidateLight = ({ item, langId, isDesktop }) => {
  function formatFilename(filename, ext) {
    // Convert the filename to lowercase and replace spaces with underscores
    const formattedName = filename
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // remove diacritical marks
      .replace(/-/g, "") // remove hyphens
      .replace(/'/g, "") // remove single quotes
      .toLowerCase()
      .replace(/ /g, "_");

    // Append the extension
    return formattedName + "." + ext;
  }
  const names = item.firstName + " " + item.lastName;

  return (
    <div
      className="px-2 pt-2.5 flex flex-row items-start rounded-md mb-[6px] bg-wort-background h-[70px]"
      key={item.id}
    >
      <CandidateImage
        imageUrl={`${getDataSource()}/elected/${formatFilename(names, "webp")}`}
        imageUrlFallback={`${getDataSource()}/elected/${formatFilename(
          names,
          "png"
        )}`}
      />
      <div className="flex flex-col items-start w-full ml-2">
        <span className="font-bold leading-6 text-[18px]">{names}</span>

        <div className="grid grid-cols-1 gap-1 mt-1">
          <div className="flex flex-row">
            <span className="text-xs">{locales[langId].party}</span>
            <span className="text-xs font-semibold">
              {locales.fr.mayor === item.function
                ? locales[langId].mayor
                : locales.fr.alderman === item.function
                ? locales[langId].alderman
                : locales[langId].alderwoman}{" "}
              {item.party ? " | " + item.party : ""}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

// locales[langId].noDataAvailable
export default CandidateLight;
